"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*
  Slightly hacky: list out all possible classes for purgeCSS
  sm:w-1/2, sm:w-1/3, sm:w-2/3, sm:w-1/4, sm:w-3/4, sm:w-1/5, sm:w-2/5, sm:w-3/5, sm:w-4/5, sm:w-1/6, sm:w-5/6,
  md:w-1/2, md:w-1/3, md:w-2/3, md:w-1/4, md:w-3/4, md:w-1/5, md:w-2/5, md:w-3/5, md:w-4/5, md:w-1/6, md:w-5/6,
  lg:w-1/2, lg:w-1/3, lg:w-2/3, lg:w-1/4, lg:w-3/4, lg:w-1/5, lg:w-2/5, lg:w-3/5, lg:w-4/5, lg:w-1/6, lg:w-5/6,
  xl:w-1/2, xl:w-1/3, xl:w-2/3, xl:w-1/4, xl:w-3/4, xl:w-1/5, xl:w-2/5, xl:w-3/5, xl:w-4/5, xl:w-1/6, xl:w-5/6,
 */


function Grid(props) {
  var _cx;

  var className = props.className,
      container = props.container,
      sm = props.sm,
      md = props.md,
      lg = props.lg,
      xl = props.xl,
      spacing = props.spacing,
      children = props.children;
  var innerSpacing = spacing / 2;
  var computedClassName = container ? (0, _classnames.default)(className, 'flex flex-wrap') : (0, _classnames.default)(className, 'w-full', (_cx = {}, _defineProperty(_cx, "sm:w-".concat(sm), sm), _defineProperty(_cx, "md:w-".concat(md), md), _defineProperty(_cx, "lg:w-".concat(lg), lg), _defineProperty(_cx, "xl:w-".concat(xl), xl), _cx));
  var computedStyle = container ? {
    margin: "-".concat(innerSpacing, "px"),
    width: "calc(100% + ".concat(spacing, "px)")
  } : {
    padding: innerSpacing
  };
  return _react.default.createElement("div", {
    className: computedClassName,
    style: computedStyle
  }, children);
}

Grid.propTypes = {
  className: _propTypes.default.string,
  container: _propTypes.default.bool,
  sm: _propTypes.default.string,
  md: _propTypes.default.string,
  lg: _propTypes.default.string,
  xl: _propTypes.default.string,
  spacing: _propTypes.default.number
};
Grid.defaultProps = {
  className: '',
  container: false,
  sm: null,
  md: null,
  lg: null,
  xl: null,
  spacing: 16
};

var _default = _react.default.memo(Grid);

exports.default = _default;